// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_meQueryVariables = Exact<{ [key: string]: never; }>;


export type easyreels_user_meQuery = { __typename?: 'Query', telegramBotURL: string, me: { __typename?: 'Me', displayName: string } };


export function $easyreels_user_me(opts?: { revalidate?: boolean }): easyreels_user_meQuery {
	return $easyreels_gql_user_request(`query easyreels_user_me {
  me {
    displayName
  }
  telegramBotURL
}`, undefined, opts) as easyreels_user_meQuery
}

}
